/**************************************************
 * Nombre:       Tarjeta_Galeria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Tarjeta_Galeria = ({item}) => {
    const sCell = useResponsive()

    return (

        <Grid
            container
            justifyContent={'flex-end'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${item.img})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                height: sCell ? 350 : 400,
                width: sCell ? 350 : 250,
                p: 2
            }}

        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                <Zoom>
                    <img src={item.img} style={{opacity: 0}} width={'100%'}/>
                </Zoom>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-end', zIndex: 2, mt: -6}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        border: 0.5,
                        borderColor: '#ffffff50',
                        background: 'rgba(255, 255, 255, 0.50)',
                        boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.25)',
                        backdropFilter: 'blur(4px)',
                        p: 2
                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{color: '#262626', fontSize: 15, fontWeight: 700}}>
                            {item.nombre}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            color: '#262626', fontSize: 12, fontWeight: 400, lineHeight: 1.1, textOverflow: "ellipsis",
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 3
                        }}>
                            {item.descripcion}
                        </Typography>
                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Galeria    